export const COL_WIDTH_NHC = 220;
export const NHC_VIEW_TYPES = {
  CALENDAR: "CALENDAR",
  LIST: "LIST",
};
